import { VehicleInformation } from './vehicle/vehicle-information.class';
export class SmartphotoVehicle {
    type;
    information;
    parts;
    constructor(smartphoto) {
        this.type = smartphoto.vehicleType ?? 'car';
        this.information = new VehicleInformation(smartphoto.fraudSummary, smartphoto.plate);
        this.parts =
            (this.type === 'car' && smartphoto.carpart) || (this.type === 'moto' && smartphoto.motopart) || smartphoto.vehicleParts || {};
    }
}
